<template>
  <sp-container
    ref="root"
    class="sp-layout-builder-page-builder-view"
    :class="classModifiers"
    :rowgap="rowgap"
    flex
    direction="column"
  >
    <slot />
  </sp-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { usePageBuilder } from "../../composables/page-builder";
import { usePageBuilderStore } from "../../store/page-builder";

const { showGrid, isDragging } = usePageBuilderStore();

const root = ref(null);

defineProps({
  rowgap: {
    type: String,
    default: undefined,
  },
});

const styles = {
  row: {
    background: "hsla(200, 70%, 70%, 0.1)",
    outline: "1px solid hsla(240, 70%, 50%, 0.5)",
    minHeight: "48px",
  },
  column: {
    minHeight: "48px",
  },
};

usePageBuilder(root, { styles, showGrid, isDragging });
const classModifiers = computed(() => ({
  "--show-grid": showGrid.value,
}));
</script>

<style lang="scss" scoped>
.sp-layout-builder-page-builder-view {
  --sp-comp-layout-col-background: transparent;
  --sp-comp-layout-col-outline: none;

  &.--show-grid {
    --sp-comp-layout-col-background: hsla(300, 70%, 70%, 0.1);
    --sp-comp-layout-col-outline: 1px solid hsla(340, 70%, 50%, 0.5);
  }

  ::slotted(*) {
    min-height: var(--sp-ref-spacing-24);
  }
}
</style>
